export type SessionExpiredAction = {
	type: 'SESSION_EXPIRED';
};

export default (): SessionExpiredAction => ({
	type: 'SESSION_EXPIRED',
});
